import { TGetCompanyBranchListDto } from "@/api/services/main/company/dtos/get-company-branch-list.dto";
import { convertNumberToZipCode } from "@/utils/input";
import { useCallback } from "react";

export const useConvertCompanyBranchToCsvData = () => {
  const convertCompanyToCsvData = useCallback((selectedCompanyBranches: TGetCompanyBranchListDto[]) => {
    const csvData = selectedCompanyBranches.map((branch) => {
      return {
        ["勤務先　事業所名"]: branch.branchName ? branch.branchName.toString() : "",
        ["勤務先　郵便番号"]: branch.zipCode ? convertNumberToZipCode(branch.zipCode.toString()) : "",
        ["勤務先　都道府県"]: branch.province ? branch.province : "",
        ["勤務先　市区町村"]: branch.municipality ? branch.municipality : "",
        ["勤務先　都道府県・市区町村以降"]: branch.address ? branch.address : "",
        ["勤務先　電話番号"]: branch.telNumber ? branch.telNumber : "",
        ["所定労働時間（週平均）"]: branch.weeklyWorkingHours ? branch.weeklyWorkingHours : "",
        ["所定労働時間（月平均）"]: branch.monthWorkingHours ? branch.monthWorkingHours : "",
        ["雇用保険適用事業所番号（11桁）"]: branch.businessInsuranceNumber ? branch.businessInsuranceNumber : "",
        ["労働保険番号"]: branch.employmentInsuranceNumber ? branch.employmentInsuranceNumber : "",
      };
    });
    return csvData;
  }, []);

  return { convertCompanyToCsvData };
};
